<template>
  <div>
    <div class="container">
      <div class="tabla bg-primary">
        <h5>Libramiento de San Luis Potosí</h5>
        <div class="row">
          <div class="col-sm-1"></div>
          <div class="col-sm-10 mb-4">
            <small>{{ bypassslp }}</small>
          </div>
        </div>
       
      </div>

      <div class="tabla my-4 bg-primary">
        <h5>Nodo Logístico</h5>
        <div class="row">
          <div class="col-sm-1"></div>
          <div class="col-sm-10 mb-4">
            <small>{{ node }}</small>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "board",
  props: {
    bypassslp: {
      type: String,
      request: true,
    },
    node: {
      type: String,
      request: true,
    },
  }
};
</script>

<style scoped>
.container{
  width: 95%;
  margin: auto;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap; 
  margin-bottom: 30px;
  margin-top: 30px;
}

.tabla{
  width: 100%;
  height: auto;
  margin: auto;
  border-radius: 20px;
  box-shadow: 0px 0px 4px 0px #5cabf9;
  padding: 10px;
  flex-grow: 1;
  color: white;
  background-color: #1A64AB;
}
.tabla>h5{
  text-align: center;
  font-size: 1.5em;
  margin-bottom: 20px;
  color: white;
  margin-top: 30px;
}

.tabla .col-sm-10>p{
  display: block;
  font-size: .9em;
  margin-bottom: 10px;
  text-align: justify;
  margin-bottom: 35px;
} 

.tabla:hover{
  background: #0153A2;
  color: #f1f1f2;
  transition: .5s all;
  transform: scale(1.1);
  cursor: pointer;
}
.tabla img{
  width: 30px;
  margin-bottom: 10px;
  align-items: center;
}
</style>